import React from 'react';
import { Circle, Group, Path } from 'react-konva';
import { canonicalToCanvas, ProcessedPlayer, Viewport } from '../lib';

export type PropsMarker = {
  pathData: Pick<ProcessedPlayer, 'samples'>;
  cursor: number,
  isLPS?: boolean,
  logPosition?: boolean,
  timestamps?: number[],
  rotationAngle?: null | number,
  fieldHeadingOffset: number,
  vp: Viewport;
};

const Marker = React.memo((props: PropsMarker) => {
  const {
    pathData, cursor, fieldHeadingOffset, isLPS, rotationAngle, logPosition, timestamps, vp,
  } = props;

  if (!vp || !pathData?.samples) {
    return null;
  }

  const idx = cursor === 0 ? 0 : (timestamps || []).findIndex((point) => Math.abs(cursor - point) < 400);

  if (logPosition) {
    const markerPositionText = idx !== -1 && pathData.samples[idx]
      ? `${pathData.samples[idx].x.toFixed(isLPS ? 2 : 6)}, ${pathData.samples[idx].y.toFixed(isLPS ? 2 : 6)}`
      : '';

    console.log(`Marker position ${markerPositionText}`);
  }

  if (idx === -1 || !pathData?.samples[idx]) {
    return null;
  }

  const canvasPoint = canonicalToCanvas(pathData.samples[idx], vp);

  return rotationAngle
    ? (
      <Group x={canvasPoint.cx} y={canvasPoint.cy} offsetX={17} offsetY={21} rotation={rotationAngle}>
        <Path
          data="M13.7715 22.0564C16.5641 23.8395 20.2734 23.0211 22.0564 20.2285C23.8395 17.4359 23.0211 13.7266 20.2285 11.9436C17.436 10.1605 13.7267 10.9789 11.9436 13.7715C10.1605 16.5641 10.9789 20.2734 13.7715 22.0564Z"
          fill="#FFD600"
        />
        <Path
          data="M34 8.33333C34 7.57893 32.9474 7.5023 32.6467 8.19419C30.0563 14.1548 24.0259 18.3333 17 18.3333C9.97412 18.3333 3.94371 14.1548 1.35331 8.19419C1.05262 7.5023 0 7.57893 0 8.33333C0 17.5381 7.61116 25 17 25C26.3888 25 34 17.5381 34 8.33333Z"
          fill="#FFD600"
        />
      </Group>
    )
    : <Circle x={canvasPoint.cx} y={canvasPoint.cy} radius={5} fill="red" stroke="white" />;
});

export default Marker;
